// extracted by mini-css-extract-plugin
export default {"awards":"awards__NjEyY","awardsList":"awardsList__ODllN","award":"award__OGRhO","toolTip":"toolTip__YmMwY"};